// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + "2fef185f" + "." + "ef7502b5ab464eec" + ".js";
};